export default [
  {
    path: 'gmc-catalogs',
    name: 'website.gmc.catalogs',
    component: () => import('@/views/website/gmc/catalogs'),
  },
  {
    path: 'gmc-catalogs/:id',
    name: 'website.gmc.catalogs.detail',
    component: () => import('@/views/website/gmc/catalogs/detail'),
  },
];
